import { ReactNode, useState, HTMLAttributes, useId } from "react";
import { Form } from "react-bootstrap";
export function validityResolver(
  formState: any
): (field: string) => boolean | undefined {
  const errors = formState.errors || {};
  return (field: string) => {
    const parts = field.split(/\[|\]|\./g).filter((v) => v !== "");
    if (parts.length > 1) {
      let errObj = errors;
      let tchObj = formState.touchedFields;
      for (let i = 0; i < parts.length; i += 1) {
        errObj = errObj ? errObj[parts[i]] : errObj;
        tchObj = tchObj ? tchObj[parts[i]] : tchObj;
      }
      if (errObj) {
        return false;
      } else {
        return tchObj ? true : undefined;
      }
    } else {
      return field in errors
        ? false
        : formState.touchedFields && formState.touchedFields[field]
        ? true
        : undefined;
    }
  };
}
export interface SelectItem {
  value: string | number;
  label: ReactNode;
}
export interface FileOptions {
  browseLabel?: ReactNode;
}
export interface FormInputProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode;
  field: string;
  type?: "textarea" | "select" | "file" | undefined; // this type must be defined and match equalent undocumented props of BS, which has some 200 values. Feel free to add if needed,
  resolveValidity?: (field: string) => boolean | undefined;
  autoComplete?: string;
  placeholder?: string;
  prepend?: ReactNode;
  append?: ReactNode;
  readOnly?: boolean;
  register: any;
  registerOptions: any;
  hasValue: boolean;
  selectOptions?: SelectItem[];
  fileOptions?: FileOptions;
  labelClass?: string;
  inputClass?: string;
  defaultValue?: any;
}
//</editor-fold>
const LABEL_CLASS = "placeholder-label";
const INPUT_CLASS = "form-control";
function FormInput(props: FormInputProps) {
  //<editor-fold desc="Local variables">
  let {
    children,
    label,
    prepend,
    append,
    field,
    type,
    resolveValidity,
    autoComplete,
    placeholder,
    readOnly,
    register,
    registerOptions,
    hasValue,
    selectOptions,
    fileOptions,
    labelClass,
    inputClass,
    defaultValue,
    ...other
  } = props;
  const idPrefix = useId();
  const [fileName, setFileName] = useState("");
  const validity = resolveValidity ? resolveValidity(field) : undefined;
  const inputNodeProps: any = {
    className:
      (validity === true
        ? "is-valid"
        : validity === false
        ? "is-invalid"
        : "") +
      (hasValue ? " has-value" : "") +
      " " +
      (inputClass ? inputClass : INPUT_CLASS),
    autoComplete: autoComplete ? autoComplete : undefined,
    placeholder: placeholder !== undefined ? placeholder : undefined,
    readOnly: readOnly !== undefined && readOnly !== false,
  };
  if (defaultValue) {
    inputNodeProps.defaultValue = defaultValue;
  }
  let inputNode;
  const labelNode = (
    <Form.Label
      className={
        labelClass
          ? labelClass
          : LABEL_CLASS + (prepend || append ? " on-top" : "")
      }
    >
      {label}
    </Form.Label>
  );
  if (type !== "file") {
    if (type === "textarea") {
      inputNodeProps.rows = 4;
    } else if (type === "select") {
      if (!labelClass) {
        inputNodeProps.className += " with-placeholder-label";
      }
      if (selectOptions) {
        inputNodeProps.children = selectOptions.map((itm: SelectItem) => (
          <option key={itm.value} value={itm.value}>
            {itm.label}
          </option>
        ));
      }
    }
    inputNode = (
      <Form.Control
        as={type}
        {...register(field, registerOptions)}
        {...inputNodeProps}
      />
    );
  } else {
    inputNodeProps.className += " " + INPUT_CLASS;
    const roOnChange = registerOptions.onChange;
    registerOptions = {
      ...registerOptions,
      onChange: (e: any) => {
        // console.log("injected onChange %o", e);
        if (e && e.target && e.target.files && e.target.files.length) {
          setFileName(e.target.files[0].name);
        } else {
          setFileName("");
        }
        if (roOnChange) {
          roOnChange(e);
        }
      },
    };
    inputNode = (
      <Form.File custom={true}>
        <Form.File.Input
          {...inputNodeProps}
          {...register(field, registerOptions)}
        />
        <Form.File.Label
          data-browse={
            fileOptions && fileOptions.browseLabel
              ? fileOptions.browseLabel
              : undefined
          }
        >
          {fileName}
        </Form.File.Label>
        {children}
        {labelNode}
      </Form.File>
    );
  }
  return (
    <Form.Group controlId={idPrefix + field} {...other}>
      {type !== "file" && (
        <>
          {prepend || append ? (
            <div className="input-group">
              {prepend && <div className="input-group-prepend">{prepend}</div>}
              <div className="flex-shrink-1 flex-grow-1 position-relative">
                {inputNode}
                {labelNode}
              </div>
              {append && <div className="input-group-append">{append}</div>}
            </div>
          ) : undefined}
          {!prepend && !append ? inputNode : undefined}
          {children}
          {!prepend && !append ? labelNode : undefined}
        </>
      )}
      {type === "file" && inputNode}
    </Form.Group>
  );
}
export default FormInput;
